// client/src/components/ProtectedRoute.js

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Spinner, Container } from 'react-bootstrap';

const ProtectedRoute = () => {
    const { user, isLoading } = useAuth();

    // First, we wait for the context to finish its initial check.
    // While it's loading, we can show a spinner.
    if (isLoading) {
        return (
            <Container className="text-center mt-5">
                <Spinner animation="border" />
            </Container>
        );
    }

    // After loading, if there is no user, redirect to the login page.
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // If there is a user, render the child route the user was trying to access.
    return <Outlet />;
};

export default ProtectedRoute;